export default "__VITE_ASSET__D3BP4aM___"